import React from 'react';
import PropTypes from 'prop-types';

interface GridProps extends React.HTMLAttributes<HTMLDivElement> {
  row?: boolean;
  col?: boolean;
  size?: number | 'auto';
}

class Grid extends React.Component<GridProps> {
  static propTypes = {
    row: PropTypes.bool,
    col: PropTypes.bool,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['auto'])]),
  }

  static defaultProps = {
    row: false,
    col: false,
  }

  render() {
    const { row, col, size, children, ...rest } = this.props;

    let className = '';
    if (row) className += 'row';
    if (col) className += `col-md-${size || ''}`;

    return (
      <div className={className} {...rest}>
        {children}
      </div>
    );
  }
}

export default Grid;
